import { Link } from "react-router-dom";

// The 8 cities and their slugs
export const cities = [
  { name: "Saskatoon", slug: "saskatoon" },
  { name: "Regina", slug: "regina" },
  { name: "Moose Jaw", slug: "moose-jaw" },
  { name: "Prince Albert", slug: "prince-albert" },
  { name: "Swift Current", slug: "swift-current" },
  { name: "Yorkton", slug: "yorkton" },
  { name: "Estevan", slug: "estevan" },
  { name: "Weyburn", slug: "weyburn" },
];

// The 8 services and their slugs/labels
export const services = [
  { slug: "replacement", label: "Roof Replacement" },
  { slug: "repair", label: "Roof Repair" },
  { slug: "storm-damage", label: "Storm Damage" },
  { slug: "inspection", label: "Roof Inspection" },
  { slug: "asphalt", label: "Asphalt Shingles" },
  { slug: "metal", label: "Metal Roofing" },
  { slug: "commercial", label: "Commercial" },
  { slug: "eavestrough", label: "Eavestrough" },
];

/**
 * Services-in-City section: placed on each city hub page.
 * Links to all 8 services offered in that city.
 */
export function CityServicesSection({
  city,
  citySlug,
}: {
  city: string;
  citySlug: string;
}) {
  return (
    <section className="py-20 bg-muted/30 border-t">
      <div className="container px-4 max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-4 text-center">
          All Roofing Services in {city}
        </h2>
        <p className="text-lg text-muted-foreground text-center mb-10 max-w-2xl mx-auto">
          We offer a full range of roofing services across {city} and
          surrounding Saskatchewan communities. Every quote is fixed-price, in
          writing, with no surprise fees.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {services.map((s) => (
            <Link
              key={s.slug}
              to={`/areas/${citySlug}/${s.slug}`}
              className="bg-card p-4 rounded-lg border shadow-sm hover:shadow-md transition-all text-center"
            >
              <h3 className="font-semibold text-sm md:text-base">{s.label}</h3>
              <p className="text-xs text-muted-foreground mt-1">in {city}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

/**
 * Service-in-Your-Area section: placed on each service page.
 * Links to that service in all 8 cities.
 */
export function ServiceAreasSection({
  service,
  serviceSlug,
}: {
  service: string;
  serviceSlug: string;
}) {
  return (
    <section className="py-20 bg-muted/30 border-t">
      <div className="container px-4 max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-4 text-center">
          {service} Across Saskatchewan
        </h2>
        <p className="text-lg text-muted-foreground text-center mb-10 max-w-2xl mx-auto">
          We offer {service.toLowerCase()} in eight cities across Saskatchewan,
          with local crews who understand the climate. Find your community
          below, or contact us if you don't see your town.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {cities.map((c) => (
            <Link
              key={c.slug}
              to={`/areas/${c.slug}/${serviceSlug}`}
              className="bg-card p-4 rounded-lg border shadow-sm hover:shadow-md transition-all text-center"
            >
              <h3 className="font-semibold text-sm md:text-base">{service}</h3>
              <p className="text-xs text-muted-foreground mt-1">in {c.name}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
